<div class="register-leave-combined">
  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.combined.title"></sc-dictionary-label>
    </h2>


    <div class="top-info">
      <app-transport-info-panel [carrier]="transport.carrier" [identifier]="transport.identifier"
        [driver]="transport.name" [scope]="transport.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">

      <div class="grid">

        <div class="form-box" style="grid-column: 1 / span 2; grid-row: 1;">
          <h3>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.area-gate.title"></sc-dictionary-label>
          </h3>
          <mat-form-field  appearance="fill">
            <mat-select [(value)]="selectedAreaGate">
                <mat-option *ngFor="let gate of areaGates" [value]="gate">
                    {{ gate.name }}
                </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-box" style="grid-column: 1; grid-row: 2;">
          <h3>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.combined.supplementaryequipment.title"></sc-dictionary-label>
          </h3>
          <div class="se-grid" *ngIf="supplementaryEquipmendHandouted(seTransport)">
            <ng-container *ngFor="let se of seTransport.supplementaryEquipments; let i = index">
              <div class="center" style="grid-column: 1;" [ngStyle]="{'grid-row': i + 1 }">
                <mat-checkbox [(ngModel)]="se.selected" [ngModelOptions]="{standalone: true}"
                  [disabled]="isFormReadonly()" name="{{i}}" (change)="selected(se, $event)">
                  <sc-dictionary-label [dictionaryKey]="se.dictionaryKey"></sc-dictionary-label>
                </mat-checkbox>
              </div>
              <mat-form-field style="grid-column: 2;" [ngStyle]="{'grid-row': i + 1}" *ngIf="isParam1Available(se)" appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="se.parameter1DictionaryKey"></sc-dictionary-label>
                </mat-label>
                <input matInput [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: true}" required [readonly]="true">
              </mat-form-field>
            </ng-container>
          </div>
          <div *ngIf="!supplementaryEquipmendHandouted(seTransport)">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.combined.label.nosupplementaryequipmenthandout"></sc-dictionary-label>
          </div>
        </div>

        <form #weighForm="ngForm" class="weigh-input-form" *ngIf="isWeighingActive()"
          style="grid-column: 2; grid-row: 2;">
          <div class="form-box">
            <h3>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.combined.weighing.title"></sc-dictionary-label>
            </h3>
            <div class="flex-direction-row row-flex">
              <mat-form-field class="flex-grow-1" appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.combined.weight"></sc-dictionary-label>
                </mat-label>
                <input name="value" matInput [(ngModel)]="transport.weight" #ctrlValue="ngModel" type="number" min="0"
                  [readonly]="isFormReadonly()"
                  [required]="yardPropertiesService.getEntranceMinLength() > 0"
                  appPositiveInteger>
                <mat-error *ngIf="showValuePositiveIntegerError(ctrlValue)">
                  <sc-dictionary-label dictionaryKey="tmc.weigh-transport-dialog.error.value-no-integer"></sc-dictionary-label>
                </mat-error>
              </mat-form-field>
              <sc-button mat-icon-button type="button" class="weighingButton" (click)="readWeight()" dictionaryKey="tmc.visit.overview.action.weighTransport"
                [hidden]="isAutoWeighingVisible()"
                *ngIf="yardPropertiesService.isWeighingEnabled()">
                <sc-icon iconClass="fa-balance-scale"></sc-icon>
              </sc-button>
              <mat-form-field class="margin-left" appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.common.type"></sc-dictionary-label>
                </mat-label>
                <mat-select name="type" [(ngModel)]="transport.weighingType" #ctrlType="ngModel"
                  [required]="isWeighingTypeRequired()" [disabled]="isFormReadonly()">
                  <mat-option *ngFor="let o of typeOptions" value="{{o}}">
                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.registerleave.combined.weighingType.{{o}}"></sc-dictionary-label>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </form>

        <div class="form-box" style="grid-column: 1 / span 2; grid-row: 3;">
          <h3>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.combined.checks.title"></sc-dictionary-label>
          </h3>
          <div class="checks-list">
            <ul *ngIf="checksExist(transport)">
              <li class="check" *ngFor="let check of transport.checks">
                <div class="icon">
                  <i class="fa-light"
                    [ngClass]="{'fa-check color-ok': isOk(check), 'fa-exclamation-triangle color-warn': isWarning(check), 'fa-exclamation-circle color-error': isFailed(check)}"></i>
                </div>
                <div class="message">
                  <sc-dictionary-label [dictionaryKey]="check.nameDictionaryKey"></sc-dictionary-label>
                  <ng-container *ngIf="descriptionExists(check)">
                    -
                    <sc-dictionary-label [dictionaryKey]="check.descriptionDictionaryKey"></sc-dictionary-label>
                  </ng-container>
                </div>
              </li>
            </ul>
            <span *ngIf="!checksExist(transport)">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.combined.checks.nochecks"></sc-dictionary-label>
            </span>
          </div>
        </div>
      </div>

      <form *ngIf="allowExitDespiteOfRuleViolationEnabled" [formGroup]="allowExitDespiteOfRuleViolationFormGroup">
        <mat-checkbox formControlName="allowExitDespiteOfRuleViolation" name="allowExitDespiteOfRuleViolation">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.combined.allow-exit-despite-of-rule-violations"></sc-dictionary-label>
        </mat-checkbox>
      </form>

    </div>


    <div class="messages"></div>
    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="cancel()">
        <sc-dictionary-label dictionaryKey="tmc-yard.common.action.cancel"></sc-dictionary-label>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button class="" (click)="decline()" [disabled]="isDeclineDisabled()">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.combined.action.decline"></sc-dictionary-label>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button class="confirm-button" (click)="accept()" [disabled]="isAcceptDisabled">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-leave.combined.action.accept"></sc-dictionary-label>
      </button>
    </sc-actionbar>
  </div>
